import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3.425 2.576a.6.6 0 1 0-.849.848l3.22 3.22c-.158.122-.313.245-.463.37-1.682 1.404-2.84 3.033-3.42 3.952l-.02.032c-.12.19-.239.377-.3.645a1.762 1.762 0 0 0 0 .714c.061.268.18.456.3.645l.02.031c.58.92 1.738 2.548 3.42 3.952C7.017 18.391 9.263 19.6 12 19.6c2.008 0 3.75-.65 5.201-1.55l3.375 3.374a.6.6 0 0 0 .849-.848l-3.22-3.22v-.002l-3.27-3.27v.002l-.867-.867.001-.002-3.286-3.286-.002.001-.867-.867h.002L6.8 5.95 3.425 2.577Zm5.64 7.338a3.6 3.6 0 0 0 5.02 5.02l-.866-.866a2.4 2.4 0 0 1-3.287-3.287l-.866-.867Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.08 8.4a3.6 3.6 0 0 1 3.52 3.52l4.108 4.108a17.903 17.903 0 0 0 2.38-2.994l.02-.032c.12-.19.238-.377.3-.645a1.76 1.76 0 0 0 0-.714c-.062-.268-.18-.456-.3-.645l-.02-.032c-.58-.92-1.739-2.548-3.42-3.952C16.983 5.61 14.737 4.4 12 4.4c-1.2 0-2.304.232-3.309.611l3.39 3.39Z"
    />
  </svg>
`;
